// extracted by mini-css-extract-plugin
module.exports = {"app":"_3kzxk","pageContainer":"X36OU"};